import { SvgIcon, SvgIconProps } from '@mui/material';

export function DeleteOutlineIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M6 19.001C6 20.101 6.9 21.001 8 21.001H16C17.1 21.001 18 20.101 18 19.001V9.00098C18 7.90098 17.1 7.00098 16 7.00098H8C6.9 7.00098 6 7.90098 6 9.00098V19.001ZM9 9.00098H15C15.55 9.00098 16 9.45098 16 10.001V18.001C16 18.551 15.55 19.001 15 19.001H9C8.45 19.001 8 18.551 8 18.001V10.001C8 9.45098 8.45 9.00098 9 9.00098ZM15.5 4.00098L14.79 3.29098C14.61 3.11098 14.35 3.00098 14.09 3.00098H9.91C9.65 3.00098 9.39 3.11098 9.21 3.29098L8.5 4.00098H6C5.45 4.00098 5 4.45098 5 5.00098C5 5.55098 5.45 6.00098 6 6.00098H18C18.55 6.00098 19 5.55098 19 5.00098C19 4.45098 18.55 4.00098 18 4.00098H15.5Z"
          fill="currentcolor"
        />
      </svg>
    </SvgIcon>
  );
}
